var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicationBottle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460.91 460.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke-linecap:round;stroke-width:14px;}.cls-1,.cls-3{stroke:#222456;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-2{stroke:#ed7330;}.cls-3{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.1,376.88H132.29a21.61,21.61,0,0,1-21.56-21.56V243.56c0-27.67,29.09-43.74,43.13-56.42s14-30.84,14-30.84v-6.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.63,149.49v6.81s0,18.16,14,30.84,43.12,28.75,43.12,56.42v57.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "112.24 242.89 223.71 242.89 223.71 333.77 112.24 333.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 211.3,
    y1: 95.23,
    x2: 211.3,
    y2: 127.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 244.44,
    y1: 95.23,
    x2: 244.44,
    y2: 127.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.19,128.16V80.31a15.09,15.09,0,0,1,15.05-15H262.29a15.1,15.1,0,0,1,15,15v47.85H178.17V95.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.57,351A25.64,25.64,0,0,1,346,376.59H279.53A25.63,25.63,0,0,1,254,351v-2.55a25.63,25.63,0,0,1,25.56-25.57H346a25.64,25.64,0,0,1,25.57,25.57Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 312.76,
    y1: 323.9,
    x2: 312.76,
    y2: 375.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 137.05,
    y1: 274.01,
    x2: 194.99,
    y2: 274.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 137.05,
    y1: 302.65,
    x2: 194.99,
    y2: 302.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 230.45,
    cy: 230.45,
    r: 223.45
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationBottle);
export default __webpack_public_path__ + "static/media/medicationBottle.d38cd50a.svg";
export { ForwardRef as ReactComponent };